import { useQuery } from '@tanstack/react-query';

import getHostSummary from 'Api/host/getHostSummary';

import { useHostState } from 'View/host/state';

import getHostSummaryRequest from './model/request/getHostSummaryRequest';
import getHostSummaryResponse from './model/response/getHostSummaryResponse';

const useGetHostSummary = () => {
  const { filterState } = useHostState();

  return useQuery({
    queryKey: ['host-summary', filterState],
    queryFn: async () => {
      const payload = getHostSummaryRequest(filterState);

      const response = await getHostSummary(payload);

      const result = getHostSummaryResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetHostSummary;
